// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title-div[data-v-931af0ce] {\n  text-align: left;\n  width: 100%;\n  height: 50px;\n  padding: 0% 1%;\n}\n.lbltitle[data-v-931af0ce] {\n  font-size: 2rem !important;\n  font-weight: 700 !important;\n  font-style: italic;\n}\n.lblLoginUser[data-v-931af0ce] {\n  font-size: 1rem !important;\n  font-weight: 700 !important;\n  float: right;\n  margin-top: 15px;\n}\n.line-div[data-v-931af0ce] {\n  border: solid 1px;\n}\n", ""]);
// Exports
module.exports = exports;
